module.exports = __webpack_public_path__ + "static/media/FL_map@2x.45296691.png";